// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"625ca00e","126":"403e9f2f","171":"5e1d1206","178":"e0d61963","787":"f2597058"}[chunkId] + ".chunk.js";
};